import React, { useMemo } from 'react';
import './ErrorLayout.scss';

const IMAGE_COUNT = 4;

export const ErrorLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const image = useMemo(() => `/error_${Math.floor(Math.random() * IMAGE_COUNT) + 1}.jpg`, []);

  return (
    <div className="ErrorLayout">
      <div className="ErrorLayout__image" style={{ backgroundImage: `url(${image})` }} />
      <div className="ErrorLayout__content">{children}</div>
    </div>
  );
};
